// 会话状态
export const CONVERSATION_STATUS = [
  { label: "全部", value: "" },
  { label: "进行中", value: 0 },
  { label: "已结束", value: 1 },
];

// 知识库分类
export const KNOWLEDGE_CATEGORY = [
  { label: "常见问题", value: 0 },
  { label: "业务咨询", value: 1 },
  { label: "操作指引", value: 2 },
];

// 启用状态
export const STATUS_OPTIONS = [
  { label: "全部", value: "" },
  { label: "启用", value: 1 },
  { label: "禁用", value: 0 },
];

// 热门问题状态（筛选 + 表单共用）
export const POPULAR_QUESTION_STATUS = [
  { label: "已启用", value: 1 },
  { label: "已禁用", value: 0 },
];

// 热门问题项目范围（表单 radio）
export const POPULAR_QUESTION_PROJECT_SCOPE = [
  { label: "全部项目", value: 1 },
  { label: "指定项目", value: 2 },
];

// 热门问题项目范围枚举
export const POPULAR_QUESTION_SCOPE = { ALL: 1, CUSTOM: 2 };

// 指定项目模式下最大配置行数
export const POPULAR_QUESTION_MAX_PROJECT_CONFIGS = 200;

// 未知问题处理状态（筛选）
export const UNKNOWN_ISSUE_STATUS = [
  { label: "待处理", value: 0 },
  { label: "已处理", value: 1 },
  { label: "已忽略", value: 2 },
];

// 未知问题处理状态配置
export const UNKNOWN_ISSUE_STATUS_MAP = {
  0: { label: "待处理", color: "orange" },
  1: { label: "已处理", color: "green" },
  2: { label: "已忽略", color: "default" },
};

// 提示词类型
export const PROMPT_TYPE_OPTIONS = [
  { label: "系统角色定义", value: "SYSTEM" },
  { label: "问题改写", value: "QUERY_REWRITE" },
  { label: "意图识别", value: "INTENT" },
  { label: "问题生成", value: "GENERATE_QUESTION" },
  { label: "工具调用", value: "TOOL" },
  { label: "总结归纳", value: "SUMMARY" },
];

export const PROMPT_TYPE_MAP = PROMPT_TYPE_OPTIONS.reduce((map, item) => {
  map[item.value] = item.label;
  return map;
}, {});

// 提示词模板启用状态（表单）
export const PROMPT_TEMPLATE_STATUS = [
  { label: "启用", value: 1 },
  { label: "禁用", value: 0 },
];

// 提示词版本发布状态（表单）
export const PROMPT_VERSION_STATUS = [
  { label: "当前版本", value: 0 },
  { label: "已归档", value: 1 },
];

export const PROMPT_VERSION_STATUS_MAP = {
  0: { label: "当前版本", color: "green" },
  1: { label: "已归档", color: "purple" },
};

// 提示词变量类型
export const PROMPT_VARIABLE_TYPE_OPTIONS = [
  { label: "string", value: "string" },
  { label: "number", value: "number" },
  { label: "boolean", value: "boolean" },
];

// 服务卡片跳转类型（筛选）
export const SERVICE_CARD_TARGET_TYPE = [
  { label: "全部", value: "" },
  { label: "H5页面", value: 1 },
  { label: "原生页面", value: 2 },
];

// 服务卡片跳转类型（表单）
export const SERVICE_CARD_FORM_TARGET_TYPE = [
  { label: "H5页面", value: 1 },
  { label: "原生页面", value: 2 },
];

// 服务卡片状态（筛选）
export const SERVICE_CARD_STATUS = [
  { label: "全部", value: "" },
  { label: "启用", value: 1 },
  { label: "禁用", value: 0 },
];

// 服务卡片状态（表单）
export const SERVICE_CARD_FORM_STATUS = [
  { label: "启用", value: 1 },
  { label: "禁用", value: 0 },
];

// 服务卡片固定推荐（表单）
export const SERVICE_CARD_FIXED_ENABLED = [
  { label: "否", value: 0 },
  { label: "是", value: 1 },
];

// 服务卡片跳转类型映射
export const SERVICE_CARD_TARGET_TYPE_MAP = {
  1: { label: "H5页面", color: "blue" },
  2: { label: "原生页面", color: "purple" },
};

// 服务卡片链接类型（表单）
export const SERVICE_CARD_FORM_LINK_TYPE = [
  { label: "自营业务链接", value: 1 },
  { label: "第三方链接", value: 2 },
];

// 服务卡片链接类型映射
export const SERVICE_CARD_LINK_TYPE_MAP = {
  1: { label: "自营业务链接", color: "blue" },
  2: { label: "第三方链接", color: "orange" },
};

// 服务卡片图片人设（表单上传位，type 为字符串）
export const SERVICE_CARD_IMAGE_PERSONAS = [
  { label: "钱小i", value: "1" },
  { label: "忙小哎", value: "2" },
  { label: "爱小爱", value: "3" },
];

// 知识库状态（筛选）
// 后端 CommonStatusEnum：0=开启，1=关闭；与热门问题/服务卡片/提示词模块
// （1=启用、0=禁用）的取值约定正好相反，勿复用其他模块的状态常量
export const KNOWLEDGE_STATUS = [
  { label: "全部", value: "" },
  { label: "开启", value: 0 },
  { label: "关闭", value: 1 },
];

// 知识库状态映射（表格标签）
export const KNOWLEDGE_STATUS_MAP = {
  0: { label: "开启", color: "green" },
  1: { label: "关闭", color: "red" },
};

// 知识库状态（表单）
export const KNOWLEDGE_FORM_STATUS = [
  { label: "开启", value: 0 },
  { label: "关闭", value: 1 },
];

// 文档处理状态映射（0=处理中，1=处理成功，2=处理失败；非成功时不可操作）
export const DOCUMENT_PROCESS_STATUS_MAP = {
  0: { label: "处理中", color: "orange" },
  1: { label: "处理成功", color: "green" },
  2: { label: "处理失败", color: "red" },
};
